// Definición ÚNICA de String.prototype.isEmpty (M8)
//
// Se importa al INICIO del pack `application.js` (antes de `import "controllers"`),
// de modo que el método existe en el bundle antes de que corra cualquier controller.
// Antes estaba duplicada en 9+ archivos (setValue, preferences, wizard, swal, admin,
// room_channel, validate, installation, assistantOnline) — se eliminaron las copias.
String.prototype.isEmpty = function () {
    return (this.length === 0 || !this.trim());
}
